import {boundMethod} from "autobind-decorator";
import React from "react";
import {IntlContext, IntlShape} from "react-intl";
import AsyncSelect from "react-select/async";
import {MenuPlacement, OptionTypeBase, ValueType} from "react-select/src/types";

import {customStyles} from "./models";

import T, {intl2Str} from "@translate/T";

interface IAsyncSelectsProps<TValue> {
    selected: TValue | null;
    options: TValue[];

    className?: string;
    inputId?: string;
    menuPlacement?: MenuPlacement;

    onSelected(value: TValue, id?: string): void;
    retrieve(query: string): void;
    getDisplayName(option: TValue): string;
}

class AsyncSelects<TValue extends OptionTypeBase> extends React.PureComponent<
    IAsyncSelectsProps<TValue>
> {
    @boundMethod
    public onSelected(value: ValueType<TValue>) {
        const {inputId, onSelected} = this.props;
        if (value) {
            // asyncSelect sometimes throws random undefiend, therefore we need to catch those.
            onSelected(!Array.isArray(value) ? value : value[0], inputId);
        }
    }

    public render() {
        return <IntlContext.Consumer children={this.renderIntl} />;
    }

    @boundMethod
    private renderIntl(intl: IntlShape) {
        const {
            className,
            inputId,
            selected,
            options,
            retrieve,
            getDisplayName,
        } = this.props;
        const loadingMessage = () => intl2Str(intl, "Loading...");
        const noOptionsMessage = () => intl2Str(intl, "No match.");

        return (
            <AsyncSelect<TValue>
                id={"async-select-" + inputId}
                className={className}
                cacheOptions={true}
                defaultOptions={options}
                inputId={inputId}
                loadingMessage={loadingMessage}
                menuPlacement="top"
                noOptionsMessage={noOptionsMessage}
                placeholder={<T>Please select...</T>}
                styles={customStyles}
                value={selected}
                getOptionLabel={getDisplayName}
                loadOptions={retrieve}
                onChange={this.onSelected}
            />
        );
    }
}

export default AsyncSelects;
